import { Phases } from "./phases";

const restrictROITemplate = ({ templateToRestrict, roi }) => {
  return templateToRestrict !== Phases.ROI || roi
    ? templateToRestrict
    : Phases.VALUE_HYPOTHESIS;
};

export default restrictROITemplate;
